<template>
    <dropdown-confirmation
            name="saveChart"
            size="lg"
            direction="right"
            triggerBtnClass="btn-light"
            triggerBtnHtml='<i class="fa fa-pie-chart"></i>&nbsp;&nbsp;Save Chart'
            confirmBtnClass="btn-success"
            confirmBtnHtml='<i class="fa fa-check"></i>&nbsp;&nbsp;Save'
            @confirm="saveChart"
    >
        <slot>
            <div class="row">
                <div class="col">
                    <p>
                        <strong>SAVE CHART</strong><br /><br />
                        Give this report a name in order to re-run or reference it later. Saved reports are visible on the dashboard.
                    </p>
                </div>
            </div>

            <div class="row lined">
                <div class="col-4 col-form-label">Name</div>
                <div class="col-8">
                    <input type="text" class="form-control" v-model="name">
                </div>
            </div>

            <div class="row lined">
                <div class="col-4 col-form-label">Chart Type</div>
                <div class="col-8">
                    <dropdown :list="types" v-model="chart_type"></dropdown>
                </div>
            </div>

            <div class="row lined" v-show="chart_type != 'Value'">
                <div class="col-4 col-form-label">X Axis</div>
                <div class="col-8">
                    <dropdown :list="xOpts | colnames" v-model="xaxis"></dropdown>
                </div>
            </div>

            <div class="row lined">
                <div class="col-4 col-form-label">Y Axis</div>
                <div class="col-8">
                    <dropdown :list="yOpts | colnames" v-model="yaxis"></dropdown>
                </div>
            </div>


            <div class="row lined" v-show="chart_type != 'Value'">
                <div class="col-4 col-form-label">Data Points</div>
                <div class="col-8">
                    <dropdown :list="points" v-model="num_results"></dropdown>
                </div>
            </div>

        </slot>

    </dropdown-confirmation>
</template>


<script type="text/babel">
    import DropdownConfirmation from './DropdownConfirmation.vue';
    import Dropdown from './Dropdown.vue';
    export default {
        name: "SaveReport",
        data: function(){
            return {
                name: '',
                xaxis: '',
                yaxis: '',
                num_results:'',
                chart_type:''
            }
        },
        components:{
            DropdownConfirmation,
            Dropdown
        },
        filters:{
            colnames (opts){
                return opts.map((c) => { return c.display });
            }
        },
        methods:{
            resetChart(){
                this.name= '';
                this.xaxis= '';
                this.yaxis= '';
                this.num_results= '';
                this.chart_type= '';
            },
            saveChart(){
                var _this = this;

                var x_field = this.xOpts.filter(function(c){
                    return c.display == _this.xaxis
                }).map(function(c){
                    return c.key;
                })[0];

                var y_field = this.yOpts.filter(function(c){
                    return c.display == _this.yaxis
                }).map(function(c){
                    return c.key;
                })[0];

                 var data =  {
                    name: this.name,
                    x_field: x_field,
                    y_field: y_field,
                    chart_type: this.chart_type,
                    num_results: this.num_results,
                    base_function: this.fn
                };

                data.reportString = this.$route.fullPath;
                data.search = this.filters;

                this.$send(this, 'userChartCreate',data).then(r => {
                    this.$store.commit('setStatus', {
                        status: true,
                        message: "Chart saved!"
                    });
                    this.resetChart();
                });

            },
            setDefaultChart(){
                return
            }
        },
        props:{
            xOpts:{
                // Requires of objects with name/value keys
                type: Array,
                required:true
            },
            yOpts:{
                type: Array,
                required:true
            },
            types:{
                type: Array,
                required:false,
                default: () => ['Bar', 'Line', 'Pie', 'Value'],
            },
            points:{
                type: Array,
                required:false,
                default: () => [5, 10, 15]
            },
            fn:{
                type: String,
                required:true
            },
            filters:{
                type: Object,
                required:true
            }
        }

    }
</script>


// WEBPACK FOOTER //
// SaveChart.vue?c0d93634